import { MyActivitiesType } from './myActivitiesTypes';
import { MyActivityImpl } from '../../API/my-activities/implements/my-activity.impl';
import { MyActivitiesTypeEnum } from '../../API/event/dto/enums/my-activities-type.enum';

export const getSortedMyActivitiesByStartTime = (
  activities: [MyActivityImpl[], MyActivityImpl[]],
  take: number,
  type: MyActivitiesType
): {
  activities: MyActivityImpl[];
  eventCount: number;
  roomCount: number;
} => {
  const eventActivities = activities[0].map((item) => {
    return {
      type: MyActivitiesTypeEnum.EVENTS,
      activity: item,
    };
  });

  const roomActivities = activities[1].map((item) => {
    return {
      type: MyActivitiesTypeEnum.MEETING_ROOM,
      activity: item,
    };
  });

  const sortedActivities = [...eventActivities, ...roomActivities]
    .sort((a, b) =>
      type === MyActivitiesType.FUTURE
        ? a.activity.item.fromDate - b.activity.item.fromDate
        : b.activity.item.fromDate - a.activity.item.fromDate
    )
    .slice(0, take);

  let eventActivitiesCount = 0;
  let roomActivitiesCount = 0;

  sortedActivities.forEach((activity) => {
    if (activity.type === MyActivitiesTypeEnum.EVENTS) {
      eventActivitiesCount++;
    } else {
      roomActivitiesCount++;
    }
  });

  return {
    activities: sortedActivities.map((item) => item.activity),
    eventCount: eventActivitiesCount,
    roomCount: roomActivitiesCount,
  };
};
